import FeedbackThankYouPage from './FeedbackThankYouPage'

export default FeedbackThankYouPage
